import { AppThunk } from '~/app/rootReducer'
import api from '~/app/api'

interface Department {
  id: number
  name: string
  email?: string
  status: 'active' | 'suspended'
  workspaceId: string
  createdAt: Date
  updatedAt: Date
}

interface DepartmentsState {
  loading: boolean
  departments?: Department[]
}

const FETCH_DEPARTMENTS_REQUESTED = 'departments/FETCH_DEPARTMENTS_REQUESTED'
const FETCH_DEPARTMENTS_RECEIVED = 'departments/FETCH_DEPARTMENTS_RECEIVED'

const initialState: DepartmentsState = {
  departments: undefined,
  loading: false
}

export default (state = initialState, action): DepartmentsState => {
  switch (action.type) {
    case FETCH_DEPARTMENTS_REQUESTED:
      return {
        ...state,
        loading: true
      }

    case FETCH_DEPARTMENTS_RECEIVED:
      return {
        ...state,
        loading: false,
        departments: action.departments
      }

    default:
      return state
  }
}

export const fetchDepartments = (): AppThunk => {
  return async (dispatch, getState) => {
    const { departments: state } = getState()

    if (state.loading) {
      return
    }

    dispatch({ type: FETCH_DEPARTMENTS_REQUESTED })

    try {
      const { data } = await api.getSecured().get('/admin/workspace/departments')
      dispatch({ type: FETCH_DEPARTMENTS_RECEIVED, departments: data.payload.departments })
    } catch (err) {
      console.error('Failed to fetch departments:', err)
      dispatch({ type: FETCH_DEPARTMENTS_RECEIVED, departments: [] })
    }
  }
}
